function parseTermsToArray(text) {
  return String(text || "")
    .split("\n")
    .map((s) => s.trim())
    .filter(Boolean);
}

function toOpt(v) {
  if (v === "" || v == null) return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

/** Structured ACE quotation fields for API (no generic quotationCharges). */
export function mapQuotationDocToPayload(doc) {
  return {
    customerName: (doc.customerName || "").toString().trim(),
    quotationRefNo: doc.quotationRefNo,
    quotationDate: doc.quotationDate,
    fromLocation: (doc.fromLocation || "").toString().trim(),
    toLocation: (doc.toLocation || "").toString().trim(),
    distanceKm: toOpt(doc.distanceKm),
    loadDescription: (doc.loadDescription || "").toString().trim(),
    totalCft: toOpt(doc.totalCft),
    declaredLuggageValue: toOpt(doc.declaredLuggageValue),
    carrierRiskPercent: toOpt(doc.carrierRiskPercent),
    gstPercent: toOpt(doc.gstPercent),
    gstAmount: doc.gstAmount === "" ? null : toOpt(doc.gstAmount),
    transportationChargesAmount: toOpt(doc.transportationChargesAmount),
    carTransportationChargesAmount: toOpt(doc.carTransportationChargesAmount),
    loadingChargesAmount: toOpt(doc.loadingChargesAmount),
    unloadingChargesAmount: toOpt(doc.unloadingChargesAmount),
    unpackingRearrangingChargesAmount: toOpt(doc.unpackingRearrangingChargesAmount),
    shuttleLongCarryEscortChargesAmount: toOpt(doc.shuttleLongCarryEscortChargesAmount),
    carrierRiskChargesAmount: toOpt(doc.carrierRiskChargesAmount),
    paymentTerms: (doc.paymentTerms || "").toString().trim(),
    quotationIntro: (doc.quotationIntro || "").toString().trim(),
    quotationPdfNote: (doc.quotationPdfNote || "").toString().trim(),
    handymanServicesNote: (doc.handymanServicesNote || "").toString().trim(),
    extraHandlingAndStorageNote: (doc.extraHandlingAndStorageNote || "").toString().trim(),
    localUnionOctroiNote: (doc.localUnionOctroiNote || "").toString().trim(),
    validityDays: toOpt(doc.validityDays),
    moveWindowDays: toOpt(doc.moveWindowDays),
    transitTimeNote: (doc.transitTimeNote || "").toString().trim(),
    termsAndConditions: parseTermsToArray(doc.termsAndConditionsText),
    quotationExtraNote1: (doc.quotationExtraNote1 || "").toString().trim(),
    quotationExtraNote2: (doc.quotationExtraNote2 || "").toString().trim(),
    quotationCharges: [],
  };
}

export function itemsFromApiToPayload(items) {
  return (items || [])
    .filter((row) => (row.itemName || "").trim())
    .map((row) => {
      const qty = Number(row.quantity);
      const quantity = Number.isFinite(qty) && qty >= 0 ? Math.max(0, Math.floor(qty)) : 0;
      const rawCft = row.cftPerItem;
      const cftPerItem =
        rawCft === "" || rawCft === null || rawCft === undefined
          ? 0
          : Math.max(0, Number(rawCft) || 0);
      return {
        itemName: row.itemName.trim(),
        normalizedItemName: row.normalizedItemName || "",
        quantity,
        cftPerItem,
        matched: !!row.matched,
        matchStatus: row.matchStatus || "Unmatched",
        rawImportedItemName: row.rawImportedItemName || row.itemName || "",
        notes: row.notes || "",
      };
    });
}

export function computePayloadInventoryTotals(itemsPayload) {
  const valid = itemsPayload || [];
  return {
    totalItemsCount: valid.length,
    totalQuantity: valid.reduce((s, r) => s + r.quantity, 0),
    totalCft: valid.reduce((s, r) => s + r.quantity * r.cftPerItem, 0),
  };
}
